/**
 * Utility functions for shadcn/ui components.
 * @AF1.0
 */
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind CSS classes with clsx.
 * Handles conditional classes and resolves Tailwind conflicts.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** Tone semantic dùng cho Badge/health/KPI (US-AE.F0-0000-S03). */
export type Tone = "neutral" | "success" | "warning" | "danger" | "info" | "primary";

/**
 * VND hiển thị gọn theo prototype: "1.482.000.000 ₫".
 * CHỈ format hiển thị từ số đã tính sẵn (server) — KHÔNG tính toán tiền ở client
 * (bất biến TDD §2). Số âm giữ dấu "-".
 */
export function vnd(amount: number, locale = "vi-VN"): string {
  const s = Math.abs(amount).toLocaleString(locale);
  return `${amount < 0 ? "-" : ""}${s} ₫`;
}

/**
 * Props a11y cho hàng bảng click-được (board dựng `<table>` riêng, không qua DataTable).
 * role=button + tabIndex + Enter/Space kích hoạt → keyboard-only dùng được (mirror fix DataTable).
 */
export function rowClickProps(onActivate: () => void): {
  role: "button";
  tabIndex: 0;
  onClick: () => void;
  onKeyDown: (e: { key: string; preventDefault: () => void }) => void;
} {
  return {
    role: "button",
    tabIndex: 0,
    onClick: onActivate,
    onKeyDown: (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onActivate();
      }
    },
  };
}
